import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkFixer'
})
export class LinkFixerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
